exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card-wrapper {\n  margin: 0 0.313rem;\n  border-radius: 0.5rem;\n  width: 100%;\n  box-shadow: 0rem 0.188rem 0.375rem #0F172A2E;\n  border: 0.013rem solid #EBEDF0;\n  opacity: 1;\n  background-color: #FFFFFF;\n  height: 100%;\n}\n.react-multi-carousel-item {\n  margin: 0.313rem;\n}\n", ""]);

